import axios from "axios";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import config from '../component/config';

export default function DateEdit() {
  const [formValue, setFormValue] = useState({
    nomec: '',
    devise: '',
    bp: '',
    contact: '',
    adresse: '',
    responsable: '',
    initiale: '',
    poste: '',
  });

  const [logoVal, setLogo] = useState(null);
  const [signVal, setSign] = useState(null);
  const [message, setMessage] = useState('');
  const { id } = useParams();
  const navigate = useNavigate();

  // Gestion des fichiers
  const handlePhoto = (e) => {
    const { name, files } = e.target;
    if (name === "logo") setLogo(files[0]);
    if (name === "signature") setSign(files[0]);
  };

  // Gestion des champs input avec conversion en MAJUSCULES
  const handleInput = (e) => {
    const { name, value } = e.target;
    setFormValue({
      ...formValue,
      [name]: ["nomec", "initiale", "responsable"].includes(name) ? value.toUpperCase() : value
    });
  };

  // Récupération des données existantes
  useEffect(() => {
    const fetchData = async () => {
      try {
        const requestData = await fetch(`${config.apiBaseUrl}/schoolUp.php/${id}`);
        const responseData = await requestData.json();
        if (responseData.error) {
          setMessage(`❌ ${responseData.error}`);
        } else {
          setFormValue(responseData);
        }
      } catch (error) {
        console.error("Erreur lors de la récupération des données :", error);
        setMessage("❌ Erreur de connexion. Impossible de charger les détails de l'école.");
      }
    };
    fetchData();
  }, [id]);

  // Gestion de la soumission du formulaire
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const formData = new FormData();
    formData.append("id", id);
    Object.keys(formValue).forEach(key => formData.append(key, formValue[key]));
    if (logoVal) formData.append("logo", logoVal);
    if (signVal) formData.append("signature", signVal);

    try {
      const response = await axios.post(`${config.apiBaseUrl}/schoolUp.php`, formData, {
        headers: { "Content-Type": "multipart/form-data" }
      });

      if (response.data.error) {
        setMessage(`❌ ${response.data.error}`);
      } else {
        setMessage("✅ Données mises à jour avec succès !");
        setTimeout(() => navigate("/settings/"), 1500);
      }
    } catch (error) {
      console.error("Erreur lors de la mise à jour :", error);
      setMessage("❌ Échec de la mise à jour. Vérifiez votre connexion.");
    }
  };
 
  return (
    <main className="main-container">
      <div className="col-md-12 mt-4">
        <h2>Modifier les informations de l'école</h2>
        {message && <p className={`text-${message.includes("❌") ? "danger" : "success"}`}>{message}</p>}
        <form onSubmit={handleSubmit}>
          <div className="col-sm-12">
            <div className="row mb-3">
              {["nomec", "devise", "bp", "contact", "adresse", "responsable", "initiale", "poste"].map((field, idx) => (
                <div key={idx} className="form-group col-md-4">
                  <label className="mb-2">{field.replace("_", " ").toUpperCase()}</label>
                  <input type="text" className="form-control" name={field} value={formValue[field]} onChange={handleInput} />
                </div>
              ))}
              <div className="form-group col-md-3">
                <label className="mb-2">Logo</label>
                <input type="file" className="form-control" name="logo" onChange={handlePhoto} />
              </div>
              <div className="form-group col-md-3">
                <label className="mb-2">Signature</label>
                <input type="file" className="form-control" name="signature" onChange={handlePhoto} />
              </div>
            </div>
          </div>
          <div className='buttons'>
            <button className='btn btn-secondary m-3' onClick={() => navigate('/settings/')}>Retour</button>
            <button type='submit' className="btn btn-success">Enregistrer</button>
          </div>
        </form>
      </div>
    </main>
  );
}
